/*** IMPORTS FROM imports-loader ***/
var define = false;

exports.f = Object.getOwnPropertySymbols;




//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_object-gops.js
// module id = 233
// module chunks = 0